import React, { createContext, useContext, useMemo, useReducer } from 'react';

import playlistEditorReducer from './playlistEditorReducer';

const emptyPlaylistEditorContextValue = {
    selectedModel: null,
    bookToEdit: null,
    bookToEditData: null,
    onClose: () => {},
    onBookTouched: () => {},
    mediaTypeToDisplay: 'Photo',
    hideUsedPictures: false,
    extendedFilters: false,
    documentsList: [],
    isFetchingDocuments: false,
    playlistItems: [],
    activeId: null,
    previewVideo: null,
    activeItem: null,
    packageID: null,
    playlistID: null,
    singlePage: false,
};

export const PlaylistEditorContext = createContext(
    emptyPlaylistEditorContextValue
);
const PlaylistEditorDispatchContext = createContext(null);

export const PlaylistEditorContextProvider = ({
    selectedModel,
    bookToEdit,
    onClose,
    onBookTouched,
    children,
    packageID,
}) => {
    const PlaylistEditorContextValue = useMemo(
        () => ({
            ...emptyPlaylistEditorContextValue,
            selectedModel,
            bookToEdit,
            onClose,
            onBookTouched,
            packageID,
        }),
        [selectedModel, bookToEdit, onClose, onBookTouched, packageID]
    );

    const [data, dispatch] = useReducer(
        playlistEditorReducer,
        PlaylistEditorContextValue
    );

    return (
        <PlaylistEditorContext.Provider value={data}>
            <PlaylistEditorDispatchContext.Provider value={dispatch}>
                {children}
            </PlaylistEditorDispatchContext.Provider>
        </PlaylistEditorContext.Provider>
    );
};

export function usePlaylistEditor() {
    return useContext(PlaylistEditorContext);
}

export function usePlaylistEditorDispatch() {
    return useContext(PlaylistEditorDispatchContext);
}
